const defaultTexts = {
  ka: {
    title: 'საქართველოს ბანკი - გზა სულ არის, არ გაჩერდე',
    // eslint-disable-next-line max-len
    description: 'ისარგებლეთ ინდივიდუალური საბანკო მომსახურებით, მიიღეთ განსაკუთრებული შეთავაზებები და პირობები საბანკო პროდუქტებსა და მომსახურებებზე',
  },
  en: {
    title: 'Bank of Georgia',
    // eslint-disable-next-line max-len
    description: 'Take advantage of individual banking services, receive special offers and conditions on banking products and services',
  },
};

export default defaultTexts;
